import { render, staticRenderFns } from "./LibraryBookStyle.vue?vue&type=template&id=80035b72&"
import script from "./LibraryBookStyle.vue?vue&type=script&lang=js&"
export * from "./LibraryBookStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports